import { css } from "styled-components";

const themeStyles = css`
  color: var(--text-color);
  background-color: var(--elements-background);
`;

export { themeStyles };
